import React from "react";
import { Grid } from "@material-ui/core";
import { useQuery } from '@apollo/react-hooks';
import TileDefault from "../../Tiles/Default/TileDefault";
import { GET_VIEWABILITY } from "../../../queries/indicators";
import PageError from '../../PageError';
import PageLoading from '../../PageLoading';
import { momentFormat } from "../../Utils/formatters";
import { moment } from "../../Utils/momentConfig";


let card = [];

export default function ViewabilityIndicator(props) {
  var { publishers, isDashboard } = props;
  let { data: dataIndicatorsViewability, loading: loadingIndicatorsViewability, error: errorIndicatorsViewability } = useQuery(GET_VIEWABILITY, {
    variables: { publishers: publishers },
  });

  if(dataIndicatorsViewability){
    const rowViewability = dataIndicatorsViewability.reportViewabilityByPublisher;
    card = [{
      product: "Viewability",
      today: { value: rowViewability.todayViewability ? rowViewability.todayViewability.toFixed(2): 0 },
      week : rowViewability.sevenDaysByDaysViewability ? rowViewability.sevenDaysByDaysViewability.map(row => ({ quantity: row.value ? row.value.toFixed(2) : "0", 
      dateSubscribed: moment(row.date).add(1, 'days').format(momentFormat) })) : [],
      yesterday: { value: rowViewability.yesterdayViewability ? rowViewability.yesterdayViewability.toFixed(2) : 0 },
      weekly: { value: rowViewability.sevenDaysViewability ? rowViewability.sevenDaysViewability.toFixed(2): 0 },
      monthly: { value: rowViewability.monthViewability ? rowViewability.monthViewability.toFixed(2): 0 },
      color: "primary"
    }
  ];
  }
  
  return (
    <>
    {(loadingIndicatorsViewability) ? <Grid item xs={12}><PageLoading /></Grid> : 
    (errorIndicatorsViewability) ? <Grid item xs={12}><PageError /></Grid> : (!isDashboard) ?
      (
        <>
        {
        card.map(stat => (
          (<Grid item md={4} sm={6} xs={12} key={stat.product}>
            <TileDefault {...stat} />
          </Grid>)
        ))
        }
        </>
      ) : <></>
    }
    </>
  );
}